import pushEvent from '../pushEvent';

/**
 *
 * @param {*} win The window object
 * @param {*} document The document object
 * @param {*} events The event functions that return a payload that gets passed to pushEvent
 *
 * This function handles a special case where event.stopPropagation is used in ws-navigation and
 * ws-tracking is unable to see events from the widget.
 * ws-navigation fires a special ws-tracking-nav-event which we can use to invoke ws-tracking events
 */
const handleWsTrackingEventListener = (win, document, events) => {
	const wsTrackingNavEvents = {
		linkClick: 'a[href],a[data-href],button',
		hproductClick:
			'[data-showroom-listing-vehicle-id],[data-modelselector-vehicle-id]',
		navClick: '[data-navigation-id]'
	};
	document.addEventListener('ws-tracking-nav-event', ({ detail }) => {
		const { event: { nativeEvent, nativeEvent: { target } = {} } = {} } =
			detail;

		Object.entries(wsTrackingNavEvents).forEach(([type, test]) => {
			const el = target.querySelector(test) || target.closest(test);
			if (el) {
				const event = {
					// link.clicked uses currentTarget and we need the element that matches the selectors above
					currentTarget: el,
					originalEvent: nativeEvent,
					timeStamp: nativeEvent.timeStamp
				};

				if (type === 'linkClick') {
					pushEvent(win, events.link.clicked(event));
				} else if (type === 'hproductClick') {
					pushEvent(win, events.link.hproduct(event));
				} else if (type === 'navClick') {
					pushEvent(win, events.link.navigationClick(event));
				}
			}
		});
	});
};

export default handleWsTrackingEventListener;
